import { render, staticRenderFns } from "./ReestrOrganizationCard.vue?vue&type=template&id=2e763f99"
import script from "./ReestrOrganizationCard.vue?vue&type=script&lang=js"
export * from "./ReestrOrganizationCard.vue?vue&type=script&lang=js"
import style0 from "./ReestrOrganizationCard.vue?vue&type=style&index=0&id=2e763f99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports